import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from "../../../utilities/TableUtil";
import { normalColumn, dateColumn, actionColumnCustomLableWarning } from "../../../components/DataTable/DataTable.js";

import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";
import { useHistory } from "react-router-dom";

export default function P103List({ dataTable, setBillNotiDialog }) {
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    const [globalFilter, setGlobalFilter] = useState(null);
    const history = useHistory();

    const actionBodyNoti = (rowData) => setBillNotiDialog({ open: true, data: rowData });

    const headerLabel = <span className="hidden-responsive">กลับหน้าจอหลัก</span>;
    const header = (
        <div className="table-header">
            <Button className="p-button p-button-secondary btn-hidden-responsive" label={headerLabel} icon="fas fa-arrow-left" onClick={() => history.push("/102")} autoFocus />
            {/* <span className="p-input-icon-left span-responsive" >
                <i className="pi pi-search" />
                <InputText type="search" placeholder="คำค้น"
                    className="btn-responsive"
                    onInput={(e) => setGlobalFilter(e.target.value)}
                />
            </span> */}
        </div>
    );

    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable
                    // ref={(el) => dt = el}
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows}
                    onPage={(e) => onPageChange(e, setPageConf)}
                    rowsPerPageOptions={rowsPerPageOptions()}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    globalFilter={globalFilter}
                    emptyMessage="ยังไม่ได้เพิ่มรายการ"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    header={header}
                    selectionMode="single"
                >
                    {/* 95% */}
                    <Column sortable field="contractNo" header="เลขที่สัญญา" body={(e) => normalColumn(e, "contractNo", "เลขที่สัญญา")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column sortable field="routeNo" header="เส้นทาง" body={(e) => normalColumn(e, "routeNo", "เส้นทาง")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column sortable field="orderDate" header="วันที่สั่ง" body={(e) => normalColumn(e, "orderDate", "วันที่สั่ง")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column sortable field="supervisorName" header="ผู้สั่ง" body={(e) => normalColumn(e, "supervisorName", "ผู้สั่ง")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column sortable field="orderDetail" header="การสั่งการเฉพาะอย่าง" body={(e) => normalColumn(e, "orderDetail", "การสั่งการเฉพาะอย่าง")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column sortable field="guidelineNo" header="เป็นเเนวทางปฏิบัติตามข้อ" body={(e) => normalColumn(e, "guidelineNo", "เป็นเเนวทางปฏิบัติข้อ")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column sortable field="fixExpireDate" header="ปรับปรุงเเก้ไขภายในวันที่" body={(e) => normalColumn(e, "fixExpireDate", "ปรับปรุงเเก้ไขภายในวันที่")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column sortable field="urgentFixExpire_date" header="เร่งรัดดำเนินการภายในวันที่" body={(e) => normalColumn(e, "urgentFixExpire_date", "เร่งรัดดำเนินการภายในวันที่")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column sortable field="replyExpireDate" header="ตอบกลับเป็นหนังสือภายในวันที" body={(e) => normalColumn(e, "replyExpireDate", "ตอบกลับเป็นหนังสือภายในวันที")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column sortable field="orderStatus" header="สถานะ" body={(e) => normalColumn(e, "orderStatus", "สถานะ")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column header="เปิดเป็นใบเเจ้ง" body={(e) => actionColumnCustomLableWarning(e, actionBodyNoti, "เปิดใบแจ้งฯ", "pi pi-file")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER}></Column>
                </DataTable>
            </div>
        </div>
    );
}
